"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Links = exports.HistoryNav = void 0;
const react_1 = __importStar(require("react"));
const HistoryNav = (props) => {
    var _a, _b;
    let scrl = (0, react_1.useRef)(null);
    const [scrollX, setscrollX] = (0, react_1.useState)(0);
    const [scrollEnd, setscrollEnd] = (0, react_1.useState)(true);
    const slide = (shift) => {
        scrl.current.scrollLeft += shift;
    };
    const scrollCheck = () => {
        setscrollX(scrl.current.scrollLeft);
        if (Math.floor(scrl.current.scrollWidth - scrl.current.scrollLeft) <=
            scrl.current.offsetWidth) {
            setscrollEnd(true);
        }
        else {
            setscrollEnd(false);
        }
    };
    (0, react_1.useEffect)(() => {
        let isCancelled = false;
        //Check width of the scollings
        const checkScrollings = () => {
            var _a, _b;
            if (scrl.current &&
                ((_a = scrl === null || scrl === void 0 ? void 0 : scrl.current) === null || _a === void 0 ? void 0 : _a.scrollWidth) === ((_b = scrl === null || scrl === void 0 ? void 0 : scrl.current) === null || _b === void 0 ? void 0 : _b.offsetWidth)) {
                setscrollEnd(true);
            }
            else {
                setscrollEnd(false);
            }
        };
        window.addEventListener('resize', checkScrollings);
        checkScrollings();
        return () => {
            window.removeEventListener('resize', checkScrollings);
            isCancelled = true;
        };
    }, [(_a = scrl === null || scrl === void 0 ? void 0 : scrl.current) === null || _a === void 0 ? void 0 : _a.scrollWidth, (_b = scrl === null || scrl === void 0 ? void 0 : scrl.current) === null || _b === void 0 ? void 0 : _b.offsetWidth]);
    return react_1.default.createElement("div", { className: 'history-navigation' },
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: 'history-wrap position-relative mb-9 mb-md-10' },
                scrollX !== 0 && (react_1.default.createElement("div", { className: "prev position-absolute h-100 start-0 p-0 d-flex flex-row" },
                    react_1.default.createElement("button", { className: "prev", title: 'prev', onClick: () => slide(-50) },
                        react_1.default.createElement("span", { className: 'icon-right-arrow d-flex h-100 align-items-center justify-content-end' })),
                    react_1.default.createElement("div", { className: 'mask h-100' }))),
                react_1.default.createElement("nav", { className: 'historyNav position-absolute start-0 end-0 mw-100 row g-0', role: 'navigation', "aria-label": props.pageProps.lang === 'en' ? 'History navigation' : 'Historia sivujen navikaatio' },
                    react_1.default.createElement("div", { className: 'position-relative' },
                        react_1.default.createElement("div", { className: 'line' })),
                    react_1.default.createElement("ul", { className: 'd-flex navcon align-items-center', ref: scrl, onScroll: scrollCheck },
                        react_1.default.createElement(exports.Links, Object.assign({}, props)))),
                !scrollEnd && (react_1.default.createElement("div", { className: "position-absolute h-100 end-0 p-0 d-flex flex-row" },
                    react_1.default.createElement("div", { className: 'mask h-100' }),
                    react_1.default.createElement("button", { className: "next", onClick: () => slide(+50) },
                        react_1.default.createElement("span", { className: 'icon-right-arrow d-flex h-100 align-items-center justify-content-end' })))))));
};
exports.HistoryNav = HistoryNav;
const Links = (props) => {
    const items = [];
    props.pageProps.data.linkItems.value.forEach(x => {
        const decade = x.text;
        const path = new URL(x.href).pathname;
        const active = props.pageProps.path === path || path.indexOf(props.pageProps.parentVar) !== -1 ? 'active' : '';
        const buttonProps = {
            title: decade,
            href: x.href,
            className: `decade-${decade} col d-flex flex-column align-items-center mx-5 ${active} no-outline`
        };
        items.push(react_1.default.createElement("li", { key: `history-decadenavli.${decade}` },
            react_1.default.createElement("a", Object.assign({}, buttonProps, { className: buttonProps.className, "data-prevent-page-onload-scroll": 'true' }),
                react_1.default.createElement("span", { className: 'round d-flex align-items-center justify-content-center' }),
                react_1.default.createElement("span", { className: 'decade' }, buttonProps.title))));
    });
    if (items.length > 0)
        return react_1.default.createElement(react_1.default.Fragment, null, items);
    return react_1.default.createElement(react_1.default.Fragment, null);
};
exports.Links = Links;
exports.default = exports.HistoryNav;
